<template lang="pug">
  div(class="m-block-input-copy")
    h2(class="title-24px fw-700 mb-4") {{ title }}
    v-text-field(
      :value="value"
      readonly
      hide-details
      filled
    )
      template(v-slot:append)
        v-btn(
          small
          icon
          @click.stop="copyValue"
        )
          e-svg-icon copy
    div(class="pt-8")
      v-btn(
        class="main-button w-100"
        @click.stop="copyValue"
      ) {{ $t('Copy') }}
</template>

<script>
import clipboard from '~/mixins/global/_clipboard'
import successSnackbar from '~/modules/snackbar/mixins/successSnackbar'

export default {
  name: 'MBlockInputCopy',
  mixins: [clipboard, successSnackbar],
  props: {
    closeModal: {
      type: Function,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    }
  },
  methods: {
    async copyValue() {
      try {
        await this.copy(this.value)
        this.$emit('copied')
        await this.successSnackbar.open({
          text: this.$t('Copied to clipboard'),
          icon: 'copy-success-check'
        })
      } catch (e) {
        this.$handlers.error(e, this)
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
